// extracted by mini-css-extract-plugin
export default {"container":"stylesF01_container__qvZ9E","p":"stylesF01_p__SfnP3"};